import styled from 'styled-components'

import { Dialog, media } from '@redriverpress/system'

const StyledDialogContent = styled(Dialog.Content)`
  background: ${props => props.theme.colors.gray100};
  position: fixed;
  inset: 0;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  z-index: 6;

  ${media.md`
    inset: unset;
    top: 1rem;
    left: 50%;
    transform: translateX(-50%);
    width: 90vw;
    max-height: 90vh;
  `}

  ${media.lg`
    width: 85vw;
    max-height: 85vh;
  `}

  ${media.xl`
    max-width: 65rem;
  `}
`

export default StyledDialogContent
